import React, { useEffect, useState } from "react";
import { Form } from "antd";
import ModalEditCandidate from "./ModalEditCandidate";
import moment from "moment";
import { authAxios } from "../../../../utils";
import { url_get_list_district, url_note_cv } from "../../../../constants";
import Cookies from "universal-cookie";
import { openNotificationWithIcon } from "../../../Function";

const cookies = new Cookies();

const index = ({
  typeEditForm,
  isModalOpenEditCandidate,
  setIsModalOpenEditCandidate,
  dataDetailCandidate,
  // idEdit,
  ls_city,
  listEducationLevel,
  // listLanguageSkill,
  listCandidateSource,
  handleChangeUploadCV,
  uploadFileCV,
  setUploadFileCV,
  onFinishEdit,
  listStatusCV,
  onDeleleFileCV,
  handleChangeUploadNote,
  setUploadFileNote
}) => {
  const [form] = Form.useForm();
  // const [valueCheckBoxGender, setValueCheckBoxGender] = useState("Nam");
  const [listDistrict, setListDistrict] = useState([]);
  // const [valueCheckCity, setValueCheckCity] = useState(undefined);
  const [selectedDistrict, setSelectedDistrict] = useState(undefined);
  const [dataNoteCV, setDataNoteCV] = useState([]);
  const [loadingNote, setLoadingNote] = useState(false);

  const handleCancelEditCandidate = () => {
    setIsModalOpenEditCandidate(false);
    setUploadFileCV(null);
    setUploadFileNote(null)
  };

  const onChangeCheckBoxGender = (e) => {
    form.setFieldsValue({ gender: e.target.value });
  };

  const onReloadNote = (id) => {
    setLoadingNote(true);
    authAxios(cookies.get("token"))
      .get(url_note_cv(id))
      .then((res) => {
        setDataNoteCV(res.data);
        setLoadingNote(false);
      })
      .catch((err) => {
        if (err.response !== undefined) {
          if (err.response.status === 401) {
            window.location = "/login";
          }
        }
        console.log(err);
        if (err.hasOwnProperty("data")) {
          if (err.data.hasOwnProperty("message")) {
            openNotificationWithIcon("warn", err.data.message, "");
          }
        }
        setLoadingNote(false);
      });
  };

  const handleChangeListCity = (e) => {
    setSelectedDistrict(undefined);
    form.setFieldsValue({
      district_code: undefined,
    });

    if (e == undefined) {
      setListDistrict([]);
    } else {
      // setValueCheckCity(e);
      fetchListDistrict({ city_code: e });
    }
  };

  // const fetchListCity = (params = {}) => {
  //   authAxios(cookies.get("token"))
  //     .get(url_get_list_city, { params: params })
  //     .then((res) => {
  //       setListCity(res.data);
  //     })
  //     .catch((err) => {
  //       if (err.response !== undefined) {
  //         if (err.response.status === 401) {
  //           window.location = "/login";
  //         }
  //       }
  //       console.log(err);
  //       // openNotificationWithIcon('success','Thành công','');
  //     });
  // };

  const fetchListDistrict = (params = {}) => {
    if (params.city_code != null) {
      authAxios(cookies.get("token"))
        .get(url_get_list_district, { params: params })
        .then((res) => {
          setListDistrict([]);
          setListDistrict(res.data);
        })
        .catch((err) => {
          if (err.response !== undefined) {
            if (err.response.status === 401) {
              window.location = "/login";
            }
          }
          console.log(err);
          // openNotificationWithIcon('success','Thành công','');
        });
    }
  };

  useEffect(() => {
    // form.resetFields();
    setUploadFileNote(null)
    let listExcept = [null, undefined, ""];
    if (isModalOpenEditCandidate && dataDetailCandidate) {
      // setValueCheckCity(dataDetailCandidate.city_code);
      onReloadNote(dataDetailCandidate.id)

      fetchListDistrict({ city_code: dataDetailCandidate.city_code });
      setDataNoteCV(dataDetailCandidate.data_note);

      // if (['', null].includes(dataDetailCandidate.note) == false){
      //   // TH có note
      //   dataDetailCandidate.note_date = moment(dataDetailCandidate.note_date).format("DD/MM/YYYY HH:mm:ss")
      //   setIsEdit(true);
      // } else {
      //   setIsEdit(false);
      // }

      form.setFieldsValue({
        first_name: dataDetailCandidate.first_name,
        birthday:
          dataDetailCandidate.birthday != null
            ? moment(dataDetailCandidate.birthday, "YYYY-MM-DD")
            : undefined,
        numberphone: dataDetailCandidate.numberphone,
        city_code: dataDetailCandidate.city_code,
        district_code: dataDetailCandidate.district_code,
        address: dataDetailCandidate.address,
        email: dataDetailCandidate.email,
        education_major: dataDetailCandidate.education_major,
        application_date:
          dataDetailCandidate.application_date != null
            ? moment(dataDetailCandidate.application_date)
            : undefined,

        language_skill: dataDetailCandidate.language_skill,
        // note: dataDetailCandidate.note,
        gender: dataDetailCandidate.gender,
        cv_status: dataDetailCandidate.cv_status_id,
        why_change: dataDetailCandidate.why_change_statuscv,
        ls_user_received: dataDetailCandidate.data_user_received.map(
          (item) => item.id
        ),
        user_approve_name: dataDetailCandidate.user_approve_name,
      });

      // Dùng cùng 1 form chỉnh sửa hồ sơ của page QLUV và chi tiết CV phỏng vấn nên thêm type view (chỉ đc xem)
      if (!typeEditForm) {
        form.setFieldsValue({
          education_level: dataDetailCandidate.education_level_name,
          candidate_source: dataDetailCandidate.candidate_source_name,
        });
      } else {
        form.setFieldsValue({
          education_level: listExcept.includes(
            dataDetailCandidate.education_level
          )
            ? null
            : Number(dataDetailCandidate.education_level),
          // language_skill: listExcept.includes(
          //   dataDetailCandidate.language_skill
          // )
          //   ? null
          //   : Number(dataDetailCandidate.language_skill),
          candidate_source: dataDetailCandidate.candidate_source_id,
        });
      }
    }
  }, [form, isModalOpenEditCandidate, dataDetailCandidate]);

  // useEffect(() => {
  //   fetchListCity();
  // }, []);

  // useEffect(() => {
  //   if (valueCheckCity !== undefined) {
  //     fetchListDistrict({ city_code: valueCheckCity });
  //   }
  // }, [valueCheckCity]);

  return (
    <ModalEditCandidate
      typeEditForm={typeEditForm}
      dataDetailCandidate={dataDetailCandidate}
      onFinishEdit={onFinishEdit}
      form={form}
      isModalOpenEditCandidate={isModalOpenEditCandidate}
      handleCancelEditCandidate={handleCancelEditCandidate}
      onChangeCheckBoxGender={onChangeCheckBoxGender}
      ls_city={ls_city}
      listDistrict={listDistrict}
      handleChangeListCity={handleChangeListCity}
      selectedDistrict={selectedDistrict}
      setSelectedDistrict={setSelectedDistrict}
      listEducationLevel={listEducationLevel}
      // listLanguageSkill={listLanguageSkill}
      listCandidateSource={listCandidateSource}
      handleChangeUploadCV={handleChangeUploadCV}
      uploadFileCV={uploadFileCV}
      listStatusCV={listStatusCV}
      onReloadNote={onReloadNote}
      dataNoteCV={dataNoteCV}
      loadingNote={loadingNote}
      onDeleleFileCV={onDeleleFileCV}
      handleChangeUploadNote={handleChangeUploadNote}
    />
  );
};

export default index;
